import { updatePaymentTypes } from '@engine/features/virtual_terminal/vt_update_payment_types';

function addBankNamesOptionsToDropdown(selector, banks, selectedBankName) {
  $.each(banks, function (bankCode, bankName) {
    var option = $('<option/>').attr('value', bankName).text(bankName);

    if (bankName === selectedBankName) {
      option.attr('selected', 'selected');
    }

    $(selector).append(option);
  });
}

function updateBankPayoutPaymentTypes(paymentTypes) {
  updatePaymentTypes(paymentTypes, 'bank_payout');
}

function updateBankNames(banks) {
  var selectedBank = $('#bank_payout_transaction_bank_name option:selected').val();
  var emptyValue = '<option value="">' + I18n.t('javascript.options.please_select') + '</option>';
  $('#bank_payout_transaction_bank_name').empty();
  $('#bank_payout_transaction_bank_name').append(emptyValue);
  addBankNamesOptionsToDropdown('#bank_payout_transaction_bank_name', banks, selectedBank);
  $('.for_chosen').trigger('chosen:updated');
}

var BankPayout = {
  updateBankNames: updateBankNames,
  updatePaymentTypes: updateBankPayoutPaymentTypes
};
export default BankPayout;